webpackJsonp([213534597649335],{

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(7);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _SiteConfig = __webpack_require__(6);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SEO = function (_Component) {
	  _inherits(SEO, _Component);
	
	  function SEO() {
	    _classCallCheck(this, SEO);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  SEO.prototype.render = function render() {
	    var _props = this.props,
	        projectNode = _props.projectNode,
	        projectPath = _props.projectPath,
	        projectSEO = _props.projectSEO;
	
	    var title = void 0;
	    var description = void 0;
	    var image = void 0;
	    var projectURL = void 0;
	    if (projectSEO) {
	      var projectMeta = projectNode.frontmatter;
	      title = projectMeta.title;
	
	      description = projectMeta.description ? projectMeta.description : projectNode.excerpt;
	      image = projectMeta.cover;
	      projectURL = _SiteConfig2.default.siteUrl + "/works" + projectPath;;
	    } else {
	      title = _SiteConfig2.default.siteTitle;
	      description = _SiteConfig2.default.siteDescription;
	      image = _SiteConfig2.default.siteLogo;
	    }
	    var realPrefix = _SiteConfig2.default.pathPrefix === '/' ? '' : _SiteConfig2.default.pathPrefix;
	    image = _SiteConfig2.default.siteUrl + realPrefix + image;
	    var portfolioURL = _SiteConfig2.default.siteUrl + _SiteConfig2.default.pathPrefix;
	    var schemaOrgJSONLD = [{
	      "@context": "http://schema.org",
	      "@type": "WebSite",
	      url: portfolioURL,
	      name: title,
	      alternateName: _SiteConfig2.default.siteTitleAlt ? _SiteConfig2.default.siteTitleAlt : ''
	    }];
	    if (projectSEO) {
	      schemaOrgJSONLD.push({
	        '@context': 'http://schema.org',
	        '@type': 'BreadcrumbList',
	        itemListElement: [{
	          '@type': 'ListItem',
	          position: 1,
	          item: {
	            "@id": projectURL,
	            name: title,
	            image: image
	          }
	        }]
	      }, {
	        "@context": "http://schema.org",
	        "@type": "CreativeWork",
	        url: portfolioURL,
	        name: title,
	        alternateName: _SiteConfig2.default.siteTitleAlt ? _SiteConfig2.default.siteTitleAlt : '',
	        headline: title,
	        thumbnailUrl: image,
	        description: description
	      });
	    }
	    return _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement("meta", { name: "description", content: description }),
	      _react2.default.createElement("meta", { name: "image", content: image }),
	      _react2.default.createElement("link", { rel: "apple-touch-icon", href: image }),
	      _react2.default.createElement(
	        "script",
	        { type: "application/ld+json" },
	        JSON.stringify(schemaOrgJSONLD)
	      ),
	      _react2.default.createElement("meta", { property: "og:url", content: projectSEO ? projectURL : portfolioURL }),
	      projectSEO ? _react2.default.createElement("meta", { property: "og:type", content: "article" }) : null,
	      _react2.default.createElement("meta", { property: "og:title", content: title }),
	      _react2.default.createElement("meta", { property: "og:description", content: description }),
	      _react2.default.createElement("meta", { property: "og:image", content: image }),
	      _react2.default.createElement("meta", { name: "twitter:card", content: "summary_large_image" }),
	      _react2.default.createElement("meta", { name: "twitter:title", content: title }),
	      _react2.default.createElement("meta", { name: "twitter:description", content: description }),
	      _react2.default.createElement("meta", { name: "twitter:image", content: image })
	    );
	  };
	
	  return SEO;
	}(_react.Component);
	
	SEO.propTypes = {
	  projectNode: _propTypes2.default.object,
	  projectPath: _propTypes2.default.string,
	  projectSEO: _propTypes2.default.bool
	};
	SEO.defaultProps = {
	  projectNode: {},
	  projectPath: '',
	  projectSEO: false
	};
	exports.default = SEO;
	module.exports = exports["default"];

/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(7);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _SEO = __webpack_require__(38);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _Header = __webpack_require__(16);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _ProjectListing = __webpack_require__(21);
	
	var _ProjectListing2 = _interopRequireDefault(_ProjectListing);
	
	var _Transition = __webpack_require__(39);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	var _SiteConfig = __webpack_require__(6);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	var _getWorks = __webpack_require__(55);
	
	var _getWorks2 = _interopRequireDefault(_getWorks);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PROJECT_LAYOUT = [4, 1, 2, 1, 4, 2, 2, 3, 1, 1, 1, 1, 1, 2, 1, 1, 1, 3, 1, 2, 1];
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index() {
	    _classCallCheck(this, Index);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Index.prototype.render = function render() {
	    var projectEdges = this.props.data.allMarkdownRemark.edges;
	    var works = (0, _getWorks2.default)(projectEdges);
	    return _react2.default.createElement(
	      'div',
	      { className: 'page-container' },
	      _react2.default.createElement(_reactHelmet2.default, { title: _SiteConfig2.default.siteTitle }),
	      _react2.default.createElement(_SEO2.default, { postEdges: projectEdges }),
	      _react2.default.createElement(
	        _Transition2.default,
	        null,
	        _react2.default.createElement(_Header2.default, { data: this.props.data }),
	        _react2.default.createElement(
	          'div',
	          { className: 'layout' },
	          _react2.default.createElement(_ProjectListing2.default, { projectList: works, layout: 'fixed', column: PROJECT_LAYOUT })
	        )
	      )
	    );
	  };
	
	  return Index;
	}(_react.Component);
	
	/* eslint no-undef: "off" */
	
	
	exports.default = Index;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-jsx-7673539c9d8c938a9b60.js